import axiosInstance from './axiosInstance';

export const GetAllAccountsByStore = async (store_id) => {
  try {
    const { data } = await axiosInstance.get(`/account/StoreId/${store_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAccountByID = async (account_id) => {
  try {
    const { data } = await axiosInstance.get(`/account/AccOpenBal/${account_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllAccountTypes = async () => {
  try {
    const { data } = await axiosInstance.get(`/accounttype/List`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getAccList = async (store_id) => {
  try {
    const { data } = await axiosInstance.get(`/account/list/${store_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const DeleteAccount = async (account_id) => {
  try {
    const { data } = await axiosInstance.delete(`/account/${account_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const AddAccountOpeningBal = async (store_id, acc_name, acc_description, opening_balance, acc_type_id, acc_notes) => {
  try {
    const { data } = await axiosInstance.post(`/account`, {
      store_id: store_id,
      name: acc_name,
      description: acc_description,
      balance: opening_balance,
      type_id: acc_type_id,
      notes: acc_notes,
      default: false,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditAccountOpeningBal = async (account_id, store_id, acc_name, acc_description, opening_balance, acc_type_id, acc_notes) => {
  try {
    const { data } = await axiosInstance.put(`/account/${account_id}`, {
      store_id: store_id,
      name: acc_name,
      description: acc_description,
      balance: opening_balance,
      type_id: acc_type_id,
      notes: acc_notes,
      default: false,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};